import { Decimal } from 'decimal.js';
import { formatDollarAmount, formatNumberWithCommas } from './number-formatting';
function applyDiscount(rate, discount) {
    const decimalRate = new Decimal(rate);
    if (!discount) {
        return decimalRate;
    } else {
        return discount.accept({
            whenValue: ()=>decimalRate.sub(discount.amount()),
            whenPercent: ()=>decimalRate.times(new Decimal(100).sub(discount.amount()).div(100))
        });
    }
}
function calculateFinalPrice(rate, discount, quantity) {
    const discountedRate = applyDiscount(rate, discount);
    return quantity != null ? discountedRate.mul(quantity) : discountedRate;
}
function getPriceRangeText(param) {
    let { minPrice, maxPrice, discount = null } = param;
    return minPrice != null && !minPrice.equals(0) ? "".concat(formatDollarAmount(applyDiscount(minPrice, discount).toNumber()), " - ").concat(formatDollarAmount(applyDiscount(maxPrice, discount).toNumber())) : "Up to ".concat(formatDollarAmount(applyDiscount(maxPrice, discount).toNumber()));
}
const STRIP_TRAILING_ZERO = /\.0$/;
function abbreviateNumber(value) {
    if (!Number.isFinite(value)) return String(value);
    const abs = Math.abs(value);
    if (abs >= 1000000) return "".concat((value / 1000000).toFixed(1).replace(STRIP_TRAILING_ZERO, ''), "M");
    if (abs >= 1000) {
        const thousands = (value / 1000).toFixed(1);
        if (Math.abs(Number(thousands)) >= 1000) {
            return "".concat((value / 1000000).toFixed(1).replace(STRIP_TRAILING_ZERO, ''), "M");
        }
        return "".concat(thousands.replace(STRIP_TRAILING_ZERO, ''), "k");
    }
    return formatNumberWithCommas(value);
}
function abbreviateCurrency(value) {
    if (!Number.isFinite(value)) return String(value);
    const sign = value < 0 ? '-' : '';
    return "".concat(sign, "$").concat(abbreviateNumber(Math.abs(value)));
}
function formatPercent(value) {
    if (!Number.isFinite(value)) return String(value);
    return "".concat(new Decimal(value).times(100).toFixed(1), "%");
}
/** Turns an integer of cents to a floating-point number of dollars. */ const centsToDollars = function centsToDollars() {
    let cents = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Decimal(cents).div(100).toDecimalPlaces(2).toNumber();
};
/** Turns a floating-point number of dollars to an integer of cents. */ const dollarsToCents = (dollars)=>new Decimal(dollars).mul(100).toDecimalPlaces(0).toNumber();
export const currencyUtils = {
    applyDiscount,
    calculateFinalPrice,
    formatNumberWithCommas,
    formatDollarAmount,
    getPriceRangeText,
    centsToDollars,
    dollarsToCents,
    abbreviateNumber,
    abbreviateCurrency,
    formatPercent
};
